var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.425 507.425"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.312 129.112l13.6 22 150.8 242.4c22.4 36 6 65.2-36.8 65.2h-406.4c-42.4 0-59.2-29.6-36.8-65.6l198.8-320.8c22.4-36 58.8-36 81.2 0l35.6 56.8z",
    fill: "#f3a40a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f4efef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.712 343.512c-10.8 0-20-8.8-20-20v-143.2c0-10.8 9.2-20 20-20s20 8.8 20 20v143.2c0 10.8-9.2 20-20 20zM253.312 407.112c-5.2 0-10.4-2-14-6-3.6-3.6-6-8.8-6-14s2-10.4 6-14c3.6-3.6 8.8-6 14-6s10.4 2 14 6c3.6 3.6 6 8.8 6 14s-2 10.4-6 14c-3.6 3.6-8.8 6-14 6z"
  }))));
}
export default SvgWarning;